import React from 'react'
import { useTranslation } from 'react-i18next'
import { Coupon } from 'types/coupon'
import { Button, Fonts } from 'components/base-ui'
import DineInCouponItem from 'components/dine-in/DineInCouponItem'
import { Wrapper, Header, Description, CouponListSection, CouponItemWrapper, ShareButtonWrapper } from './styled'

interface ConfirmShareCouponProps {
  coupons: Coupon[]
  onConfirm: VoidFunction
  onCancle: VoidFunction
  isProcessing: boolean
}

const ConfirmShareCoupon = ({ coupons, onConfirm, onCancle, isProcessing }: ConfirmShareCouponProps) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Header>
        <Fonts.H2>{t('dineIn.coupon.confirmSharing.title')}</Fonts.H2>
        <Description>{t('dineIn.coupon.confirmSharing.description')}</Description>
      </Header>
      <CouponListSection>
        {coupons.map((coupon, index) => (
          <CouponItemWrapper key={index} borderTop={index !== 0}>
            <DineInCouponItem onClickCondition={() => {}} coupon={coupon} isShowClickIcon={false} />
          </CouponItemWrapper>
        ))}
      </CouponListSection>
      <ShareButtonWrapper>
        <Button md onClick={onConfirm} isProcessing={isProcessing}>
          {t('dineIn.coupon.confirmSharing.confirm')}
        </Button>
        <Button md outline onClick={onCancle}>
          {t('dineIn.coupon.confirmSharing.cancel')}
        </Button>
      </ShareButtonWrapper>
    </Wrapper>
  )
}

export default ConfirmShareCoupon
